"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validatorFor = void 0;
const ajv_1 = __importDefault(require("ajv"));
const errors_1 = require("../errors");
const SchemaResolver_1 = require("./SchemaResolver");
function validatorFor(modelClass, options) {
    const resolver = new SchemaResolver_1.SchemaResolver({ refPrefix: 'defs#' });
    const schema = {
        $id: 'schema',
        additionalProperties: options?.removeAdditional === false,
        ...resolver.generateSchemaForModel(modelClass),
    };
    const definitions = {
        $id: 'defs',
        ...resolver.getSchemas(),
    };
    const ajv = new ajv_1.default({
        allErrors: true,
        verbose: true,
        nullable: true,
        removeAdditional: 'failing',
        ...options,
    });
    const validate = ajv.addSchema(definitions).compile(schema);
    return (data) => {
        const isValid = validate(data);
        if (!isValid) {
            const issues = (validate.errors ?? []).map((issue) => {
                const schemaPath = issue.schemaPath.replace(/^#|^defs#[/]/, (text) => {
                    if (text === '#') {
                        return modelClass.name;
                    }
                    else {
                        return '';
                    }
                });
                const propertyPattern = /[/]properties[/]([^/]+)/;
                const [, property] = propertyPattern.exec(schemaPath) ?? [];
                return {
                    ...issue,
                    schemaPath,
                    model: schemaPath.split('/')[0],
                    property: property ?? issue.params.missingProperty,
                };
            });
            const issueType = {
                type: errors_1.ValidationErrorCode.invalidType,
                required: errors_1.ValidationErrorCode.requiredValue,
                enum: errors_1.ValidationErrorCode.invalidValue,
                format: errors_1.ValidationErrorCode.invalidValue,
                minimum: errors_1.ValidationErrorCode.invalidValue,
                maximum: errors_1.ValidationErrorCode.invalidValue,
                minLength: errors_1.ValidationErrorCode.invalidValue,
                maxLength: errors_1.ValidationErrorCode.invalidValue,
                pattern: errors_1.ValidationErrorCode.invalidValue,
            };
            const vIssues = issues.map((x) => {
                return new errors_1.ValidationIssue(x.model, issueType[x.keyword] ??
                    errors_1.ValidationErrorCode.unknownIssueType, x.property || x.dataPath, typeof x.data !== 'object' ? x.data : 'unknown', x.dataPath || x.property, x.message);
            });
            const error = new errors_1.ValidationError();
            error.addValidationIssueList(vIssues);
            throw error;
        }
        return data;
    };
}
exports.validatorFor = validatorFor;
